//@flow
import React from 'react';
import theme from './ResizerOverlay.scss';
import classnames from 'classnames';
import Icon from 'common/components/core/icon';
import { ScreenSizeStates } from './ColumnResizeHelper';

type Props = {
    isResizing: boolean,
    screenSizeState: string,
    nextScreenSizeState: ?string
};

class ResizerOverlay extends React.PureComponent<Props, void> {
    renderScreenResizeOverlayIcons = (screenSizeState, nextScreenSizeState) => {
        const leftArrows = (
            <div className={theme.leftArrows}>
                <Icon theme={theme} icon="arrow-left" />
                <Icon theme={theme} icon="arrow-left" />
            </div>
        );
        const rightArrows = (
            <div className={theme.rightArrows}>
                <Icon theme={theme} icon="arrow-right" />
                <Icon theme={theme} icon="arrow-right" />
            </div>
        );
        switch (nextScreenSizeState) {
            case ScreenSizeStates.Min: {
                return (
                    <div className={theme.leftSnap}>
                        <div className={theme.leftBorder} />
                        {leftArrows}
                    </div>
                );
            }
            case ScreenSizeStates.Default: {
                return (
                    <div className={theme.defaultSnap}>
                        {screenSizeState !== ScreenSizeStates.Max
                            ? rightArrows
                            : null}
                        <div className={theme.defaultBorder} />
                        {screenSizeState !== ScreenSizeStates.Min
                            ? leftArrows
                            : null}
                    </div>
                );
            }

            case ScreenSizeStates.Max: {
                return (
                    <div className={theme.rightSnap}>
                        {rightArrows}
                        <div className={theme.rightBorder} />
                    </div>
                );
            }
        }
    };

    render() {
        const { isResizing, screenSizeState, nextScreenSizeState } = this.props;
        return isResizing ? (
            <div
                className={classnames(theme.overlay, {
                    [theme.isResizing]: isResizing
                })}
            >
                {this.renderScreenResizeOverlayIcons(
                    screenSizeState,
                    nextScreenSizeState
                )}
            </div>
        ) : null;
    }
}

export { ResizerOverlay };
export default ResizerOverlay;
